import  { createContext } from 'react';

const HandleRefreshQuestions = createContext();
export default HandleRefreshQuestions;